<template>
    <div class="request-form" style="background: #fff">
    <body>
        <h1>Plepower App Privacy Policy</h1>
        
        <div class="header-info">
            <p><strong>Effective Date:</strong> June, 2025</p>
        </div>
        <router-link to="/register" class="back-link"> ← Back</router-link>
        <br/><br/>
        <p>Welcome to PlePower, also known as ProLegacyPower ("we", "our", or "us"). We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application ("App"), website, and associated services (collectively, "Services").</p>
        
        <p>By using PlePower, you consent to the practices described in this Privacy Policy.</p>
        
        <h2>1. Information We Collect</h2>
        
        <h3>a. Personal Information</h3>
        <p>When you register or interact with PlePower, we may collect:</p>
        <ul>
            <li>Full Name</li>
            <li>Phone Number</li>
            <li>Email Address</li>
            <li>Home or Office Address (for service delivery)</li>
            <li>Payment Information (processed via secure third-party gateways)</li>
            <li>Meter Number or Energy ID</li>
        </ul>
        
        <h3>b. Optional Permissions</h3>
        <p>With your consent, the app may request access to:</p>
        <ul>
            <li>Contacts (for referrals or peer-to-peer top-ups)</li>
            <li>Location (to suggest regional power providers)</li>
        </ul>
        
        <h2>2. How We Use Your Information</h2>
        <p>We use the collected data to:</p>
        <ul>
            <li>Provide seamless purchase and vending of power units</li>
            <li>Send transaction receipts and alerts</li>
            <li>Improve app performance and customer experience</li>
            <li>Comply with regulatory requirements (e.g., NDPR)</li>
            <li>Detect and prevent fraudulent or unauthorized activities</li>
        </ul>
        
        <h2>3. Sharing of Your Information</h2>
        <p>We do not sell or rent your personal information. However, we may share data with:</p>
        <ul>
            <li>Payment processors</li>
            <li>Metering service providers or electricity distribution companies for credit delivery</li>
            <li>Regulatory authorities (upon valid legal request)</li>
            <li>Service providers for analytics, hosting, and fraud detection</li>
        </ul>
        
        <h2>4. Data Retention</h2>
        <p>We retain user data for as long as necessary to fulfill the purposes outlined in this policy, including legal, operational, and security requirements. You may request data deletion at any time (see Section 7).</p>
        
        <h2>5. Security Measures</h2>
        <p>We implement industry-standard safeguards such as:</p>
        <ul>
            <li>End-to-end encryption</li>
            <li>Role-based access control (RBAC) on all internal tools</li>
            <li>Encrypted storage</li>
        </ul>
        
        <h2>6. Your Privacy Rights</h2>
        <p>As a user, you have the right to:</p>
        <ul>
            <li>Access your personal data</li>
            <li>Request corrections or updates</li>
            <li>Request deletion of your data</li>
            <li>Opt out of non-essential communications</li>
        </ul>
        
        <div class="highlight">
            <p>To exercise these rights, contact us at:<br>
            📧 <a href="mailto:info@plepower.com.ng">info@plepower.com.ng</a></p>
        </div>
        
        <h2>7. Data Deletion Request</h2>
        <p>If you wish to delete your account or any associated personal information, please fill out our Data Deletion Request Form: <router-link to="/request/account/delete">https://plepower.com.ng/request/account/delete</router-link></p>
        <p>We will process your request within 7 working days, subject to any legal obligations.</p>
        
        <h2>8. Third-Party Links and Services</h2>
        <p>PlePower may contain links to third-party services. We are not responsible for the privacy practices of these providers. We encourage you to review their policies independently.</p>
        
        <h2>9. Children's Privacy</h2>
        <p>PlePower is not intended for users under the age of 18. We do not knowingly collect data from minors.</p>
        
        <h2>10. Updates to This Policy</h2>
        <p>We may update this Privacy Policy periodically. Any changes will be posted here, and major updates will be communicated via email or app notifications.</p>
        
        <div class="last-updated">
            <p>Last updated: June, 2025</p>
        </div>
        
        <div class="contact-box">
            <h2>Contact Us</h2>
            <p>For questions, concerns, or feedback regarding this Privacy Policy, please reach out:</p>
            <p>📧 <a href="mailto:info@plepower.com.ng">info@plepower.com.ng</a><br>
            🌍 <a href="https://plepower.com.ng" target="_blank">www.plepower.com.ng</a></p>
        </div>
    </body>
    </div>
    </template>
    <script>
    import swal from 'sweetalert2';
    import $ from 'jquery';
    
    export default {
        
        data() {
        return {
            logo_url: process.env.VUE_APP_API_LOGO,
            company_phone: '',
            company_email: '',
            company_name: '',
            company_address: '',
            loading: false,
            fullname: '',
            email_address: '',
            phone_number: '',
            message: '',
            request_message: '',
            
        };
      },
    
      mounted() {
    
        $(document).ready(function() {
        $(window).scroll(function() {
            if ($(this).scrollTop() > 100) {
                $('.top').fadeIn();
               document.getElementById('top-header').style.display = 'none'
              
            } else {
                $('.top').fadeOut();
                if ($(this).scrollTop() == 0) {
                    document.getElementById('top-header').style.display = 'flex'
                }
            }
           
        });
    
        $('.top').click(function() {
            $('html, body').animate({scrollTop: 0}, 800);
            return false;
            });
        });
    
        setInterval(() => {
            this.showImage = this.showImage === 2 ? 1 : this.showImage + 1;
        }, 10000); // Toggle images every 3 seconds
    
        document.title = this.title
    
        this.config_data()
       
      },
      beforeDestroy() {
       
      },
        created(){
    
        },
        computed: {
        isSubmitButtonDisabled() {
            return (
            this.fullname === '' ||
            this.email_address === '' ||
            this.message === '' 
            );
        }
      },
    
      methods: {
        async submit_form() {
                try {
    
                    this.loading = true
    
                    const response = await this.$http.post('/request-message', {
                      fullname: this.fullname,
                      email_address: this.email_address,
                      message: this.message
                    })
    
                    this.loading = false
    
                    if( !response.data.success ){
                        swal.fire({
                            icon: 'error',
                            title: 'Error',
                            width: 450,
                            height: 5,
                            text: response.data.message,
                        })
                        return;
                    }
    
                    swal.fire({
                        icon: 'success',
                        title: 'Successful',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                    })
    
                    this.fullname = ''
                    this.email_address = ''
                    this.message = ''
    
                    return;
                   
                } catch (err) {
                  console.log(err);
            }
        },
    
        async config_data() {
            const response = await fetch('/config.json');
            const configData = await response.json();
    
            this.company_phone = configData.phoneNumber
            this.company_email = configData.emailAddress
            this.company_address = configData.address
            this.request_message = configData.requestMessage
    
        }
      },
        
    }
    </script>
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Mulish:wght@300;400;500;700&display=swap');
    
      .request-form{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;

      }

      body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 900px;
            margin: 0 auto;
            padding: 20px;
        }
        .back-link {
            display: inline-block;
            margin-bottom: 0px;
            color: #3498db;
            text-decoration: none;
            font-weight: 500;
        }
        .back-link:hover {
            text-decoration: underline;
        }
        h1 {
            color: #2c3e50;
            border-bottom: 2px solid #3498db;
            padding-bottom: 10px;
        }
        h2 {
            color: #2980b9;
            margin-top: 30px;
        }
        h3 {
            color: #16a085;
        }
        .header-info {
            background-color: #f8f9fa;
            padding: 15px;
            border-left: 4px solid #3498db;
            margin-bottom: 30px;
        }
        ul {
            padding-left: 20px;
        }
        li {
            margin-bottom: 8px;
        }
        .highlight {
            background-color: #e8f4fc;
            padding: 15px;
            border-radius: 5px;
            margin: 20px 0;
        }
        .contact-box {
            background-color: #f0f7ff;
            padding: 20px;
            border-radius: 5px;
            margin-top: 30px;
        }
        .last-updated {
            text-align: right;
            font-style: italic;
            color: #7f8c8d;
        }
        @media (max-width: 768px) {
            body {
                padding: 15px;
            }
            h1 {
                font-size: 24px;
            }
        }

    </style>